import React from "react";

export default function PrivacyPolicyPage() {
  return (
    <div className="lt-main" style={{ maxWidth: 760 }}>
      <div className="lt-pagehead">
        <h1>隐私政策</h1>
        <p style={{ fontFamily: "var(--font-mono)" }}>最后更新日期：2026/01/13</p>
      </div>

      <div className="lt-prose" style={{ maxWidth: "none" }}>
        <p>
          边角聊（Leftover Talk，以下简称「我们」）致力于保护你的隐私。本隐私政策说明我们在你使用本应用时如何收集、使用和保护你的信息。
        </p>

        <h2>我们收集的信息</h2>

        <h3>账户信息</h3>
        <p>当你创建账户时，我们会收集：</p>
        <ul>
          <li>
            <strong>电子邮箱</strong> — 作为你的唯一账户标识，用于账户相关的通信
          </li>
          <li>
            <strong>密码</strong> — 使用行业标准加密技术安全存储
          </li>
        </ul>

        <h3>设备信息</h3>
        <p>为了提供服务，我们会收集：</p>
        <ul>
          <li>
            <strong>设备标识符</strong> — 由你的设备生成的唯一标识符，用于推送通知和安全验证等功能
          </li>
          <li>
            <strong>推送通知令牌</strong> — 如果你启用通知功能，我们会存储你的设备令牌以便向你发送新节目提醒
          </li>
        </ul>

        <h3>使用信息（仅存储在本地）</h3>
        <p>以下信息仅存储在你的设备上，不会传输到我们的服务器：</p>
        <ul>
          <li>播放进度和收听历史</li>
          <li>搜索历史</li>
          <li>离线收听的下载内容</li>
          <li>应用偏好设置（自动播放、通知设置等）</li>
        </ul>

        <h3>订阅信息</h3>
        <p>如果你拥有付费订阅（通过我们的网站购买）：</p>
        <ul>
          <li>应用会检查你的订阅状态以提供付费内容的访问权限</li>
          <li>我们在服务器上存储订阅状态和到期日期</li>
          <li>应用内不收集或处理任何支付信息</li>
        </ul>

        <h2>我们如何使用你的信息</h2>
        <p>我们使用你的信息用于：</p>
        <ul>
          <li>创建和管理你的账户</li>
          <li>验证你对应用和付费内容的访问权限</li>
          <li>发送新节目的推送通知（如果已启用）</li>
          <li>提供客户支持</li>
          <li>通过速率限制和验证码等安全措施防止欺诈和滥用</li>
          <li>发送账户相关的邮件（密码重置、验证码等）</li>
        </ul>

        <h2>信息共享</h2>
        <p>我们仅在提供服务所必需的情况下，与以下第三方服务共享你的信息：</p>
        <table className="lt-table">
          <thead>
            <tr>
              <th>服务</th>
              <th>用途</th>
              <th>共享的数据</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Apple 推送通知服务</td>
              <td>推送通知</td>
              <td>设备令牌</td>
            </tr>
            <tr>
              <td>阿里云</td>
              <td>邮件发送</td>
              <td>电子邮箱（用于验证码和密码重置）</td>
            </tr>
          </tbody>
        </table>
        <p>
          我们<strong>不会</strong>：
        </p>
        <ul>
          <li>出售你的个人信息</li>
          <li>与广告商共享你的数据</li>
          <li>使用第三方分析或追踪工具</li>
          <li>跨应用或网站追踪你的行为</li>
        </ul>

        <h2>数据存储与安全</h2>
        <p>你的数据通过以下方式得到保护：</p>
        <ul>
          <li>
            <strong>传输加密</strong> — 你的设备与我们服务器之间传输的所有数据均使用 HTTPS 加密
          </li>
          <li>
            <strong>安全凭证存储</strong> — 你的身份验证令牌存储在 iOS 钥匙串中，受设备安全机制保护
          </li>
          <li>
            <strong>密码安全</strong> — 密码经过高强度哈希处理，绝不以明文形式存储
          </li>
          <li>
            <strong>速率限制</strong> — 我们实施速率限制以防止暴力破解攻击
          </li>
          <li>
            <strong>令牌过期</strong> — 会话令牌在 365 天后过期以确保安全
          </li>
        </ul>

        <h2>你的权利和选择</h2>
        <p>你可以控制自己的数据：</p>
        <ul>
          <li>
            <strong>推送通知</strong> — 你可以在应用设置或设备设置中启用或禁用通知
          </li>
          <li>
            <strong>账户删除</strong> — 你可以联系我们请求删除账户，删除账户将从我们的服务器上移除所有相关数据
          </li>
          <li>
            <strong>退出登录</strong> — 退出登录会清除设备上的身份验证数据
          </li>
          <li>
            <strong>本地数据</strong> — 卸载应用会删除所有本地存储的数据，包括播放历史、下载内容和偏好设置
          </li>
        </ul>

        <h2>数据保留</h2>
        <ul>
          <li>
            <strong>账户数据</strong> — 保留至你删除账户
          </li>
          <li>
            <strong>会话令牌</strong> — 365 天后过期
          </li>
          <li>
            <strong>验证码</strong> — 5 分钟后过期
          </li>
          <li>
            <strong>本地播放数据</strong> — 90 天无活动后自动清理
          </li>
        </ul>

        <h2>设备权限</h2>
        <p>边角聊请求以下权限：</p>
        <table className="lt-table">
          <thead>
            <tr>
              <th>权限</th>
              <th>用途</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>后台音频</td>
              <td>允许你在应用处于后台或屏幕锁定时继续收听</td>
            </tr>
            <tr>
              <td>推送通知</td>
              <td>在发布新节目时向你发送提醒</td>
            </tr>
          </tbody>
        </table>
        <p>
          我们<strong>不会</strong>请求访问你的相机、麦克风、通讯录、照片或位置信息。
        </p>

        <h2>儿童隐私</h2>
        <p>
          边角聊不会故意收集 13
          岁以下儿童的个人信息。如果你认为我们无意中收集了此类信息，请立即联系我们以便删除。
        </p>

        <h2>政策变更</h2>
        <p>
          我们可能会不时更新本隐私政策。任何变更都将通过页面顶部的「最后更新日期」反映。我们建议你定期查阅本政策。
        </p>

        <h2>联系我们</h2>
        <p>
          如果你对本隐私政策或我们的数据处理方式有任何疑问或建议，请通过以下方式联系我们：
        </p>
        <p>
          <strong>邮箱：</strong>{" "}
          <a href="mailto:leftovertalk@gmail.com">leftovertalk@gmail.com</a>
        </p>
      </div>
    </div>
  );
}
